<template>
  <div>
    <div class="slide-modal-title">Edit bike</div>
    <AddEditBike
      :bike="bike"
      button-text="Save Bike"
      :hide-is-ebike-radio="true"
      @submit-bike="edit"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AddEditBike from '@/components/common/AddEditBike'

export default {
  name: 'EditBike',
  components: { AddEditBike },
  props: {
    bikeId: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      bike: {
        make: '',
        model: '',
        value: '',
      },
    }
  },
  computed: {
    ...mapState({
      bicycles: (state) => state.quote.quote.bicycles,
    }),
  },
  created() {
    this.bike = Object.assign(
      {},
      this.bicycles.find((bike) => bike.id === this.bikeId)
    )
  },
  methods: {
    ...mapActions('quote', {
      editBike: 'editBike',
    }),
    edit(bike) {
      this.editBike(bike)
      this.$modal.hide('edit-bike')
      if (this.$store.getters['quote/isMta']) {
        this.$router.push({
          path: `/quote/${this.$route.params.policyid}/start-date`,
          query: { ...this.$route.query, type: 'payment', modal: 'bike' },
        })
      }
    },
  },
}
</script>
